module.exports = __webpack_public_path__ + "img/0220809161600.7d32a00e.jpg";